/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect, forwardRef, createRef } from 'react'
import moment from 'moment'
import { FlexByRow, XDivider, YDivider, HalfScreen, useTheme, makeStyles, FlexGrowOne } from 'irmlib/styles'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import { useFormPageHandler, useMergeState, useConstructor } from 'irmlib/hooks'
import * as regx from '../../../irmlib/src/components/FormControls'
import { CancelButton, Select, DateTime, TextField, CheckBox, TextFieldBorderless } from 'irmlib/components/FormControls'
import { ContainedButton, InputAdornment, Label, Box, OutlinedButton, ThemeButton } from 'irmlib/components/Controls'
import BoxTable from '../../Controls/BoxTable'
import SearchIcon from '../../Icons/SearchIcon'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import cloneDeep from 'clone-deep'
import * as routePaths from '../../../navigation/routePaths'
import { useLocation, useHistory, Link } from 'react-router-dom'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import GoBackSubtitle from '../../Controls/GoBackSubtitle'
import { clearBusy, setBusy, closeGeneralDialog, openGeneralDialog, LocalToast } from 'irmlib/containers'
import * as constants from 'irmlib/common/constants'
import { getUser, getUserRole } from '../../../redux/global'
import { getValidations, getUserType, isSupervisor, successToast } from '../../../common/functions'
import { SearchContainer, SearchTextContainer } from '../../../styles'
import { defaultDateFormat, userRoleAdmin, userRoleSupervisor, userRoleSuperUser } from '../../../common/constants'
import { today, sameDayNextMonth } from 'irmlib/common'
import UserRolePermission from '../../Controls/UserRolePermission'
import QcDataGridBulkUpdateTable from '../../Controls/QcDataGridBulkUpdateTable'
import { useTranslation } from 'react-i18next'
import { translate } from '../../../irmlib/src/multilanguage'
import ErrorPage from '../ErrorPage'
// import { getFunctions, httpsCallable } from 'firebase/functions'

// const functions = getFunctions()

const BoxUp = styled('div')`
background-color: ${props => props.theme.palette.subPageHeaderBackground};
border-radius: ${props => props.theme.shape.borderRadius};
`

const BoxLink = styled(Link)`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
  text-overflow: clip;
`

const PrimaryLabel = styled('div')`
 cursor: pointer;
`

const BottomPaddedButton = (props) => (
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>
)

const SKP_BOX_ID = 'skpBoxId'
const CUSTOMER_ID = 'customerId'
const MAINTENANCE_CODE = 'maintenanceCode'

const minWidth = '100px'
const userTypes = {
  DATAENTRY_AND_VERIFY_USER: 'DATAENTRY_AND_VERIFY_USER',
  VERIFICATION_USER: 'VERIFICATION_USER',
  DATAENTRY_USER: 'DATAENTRY_USER'
}

const formTemplate = [
  {
    label: 'Search.searchHere',
    fieldKey: 'Search',
    isRequired: true,
    regx: regx.alphaRegex,
    regxError: regx.alphaRegexError
  },
]

const VerticalDivider = () =>
  <YDivider height='15px' />

const getService = async () => {
  const getObject = {
    obj: {

    }
  }
  return Promise.resolve(getObject)
}

const useStyles = makeStyles({
  disabledState: {
    pointerEvents: 'none',
    opacity: '0.4'
  },
  startButton: {
    textDecoration: 'none'
  }
})



const ButtonsContainer = styled(CancelButton)`
    width:150px;
`

const Buttons = (props) => {
  return (
    <>
      {
        props.showButtons
          ? <>  <ButtonsContainer id={'boxList_backButton'} onClick={props.onClickCancel} />
            <XDivider width='10px' /> {
            }
            {props.templateSelected !== 'Maintenance Box' && props.templateSelected !== 'New Box'
              ? <ContainedButton id={'boxList_startNewBox'} disabled={props.disabled} onClick={() => props.history.push(`${routePaths.dataEntry}/${props.jobId}`)}>dataEntry.startNewBox</ContainedButton>
              : <ContainedButton id={'boxList_startNewBox'} disabled={props.disabled} onClick={() => props.history.push(`${routePaths.dataEntry}/${props.jobId}`)}>dataEntry.enterBoxData</ContainedButton>}
            <XDivider width='10px' /> {
            }
            {(props.templateSelected === 'New Box' || props.templateSelected === 'Maintenance Box' || props.templateSelected === 'New File' || props.templateSelected === 'Maintenance File') && (!props.isVerify)
              ? <ContainedButton id={'boxList_Jobcomplete'} disabled={props.disabled} variant='contained' color='primary' arrRefs={props.arrRefs} onClick={props.handleJobComplete}>buttons.jobComplete</ContainedButton>
              : null}</>
          : ''
      }
    </>
  )
}

Buttons.propTypes = {
  onClickCancel: PropTypes.func,
  showButtons: PropTypes.bool,
  history: PropTypes.any,
  handleJobComplete: PropTypes.func,
  jobId: PropTypes.string,
  disabled: PropTypes.bool,
  templateSelected: PropTypes.any
}


const JobButtons = props =>
  <>
    <CancelButton id={'jobDetails_boxList_cancelButton'} onClick={props.onClickCancel} />
    <XDivider width='10px' />
    <UserRolePermission allowsTo={[userRoleAdmin, userRoleSupervisor, userRoleSuperUser]}>
      <OutlinedButton onClick={props.onClickDelete} disabled={props.jobStatus} id={'jobDetails_boxList_deleteButton'} >buttons.deleteJob</OutlinedButton>
      <XDivider width='10px' />
      <ContainedButton onClick={props.onClickEdit} disabled={props.jobStatus || (isSupervisor() && props.allowEditJob)} id={'jobDetails_boxList_editButton'}>demo.editJob</ContainedButton>
    </UserRolePermission>
  </>
JobButtons.propTypes = {
  onClickCancel: PropTypes.func,
  onClickDelete: PropTypes.func,
  onClickEdit: PropTypes.func,
  jobStatus: PropTypes.bool,
  allowEditJob: PropTypes.bool
}

const DetailsSubtitle = (props) => {
  return (
    <>
      <PrimaryLabel id={'boxList_button_boxDetails'} onClick={props.onShowBoxList} style={props.boxColor ? { color: '#1975bc' } : { color: '#58595b' }}><Label >routeTitles.boxDetails</Label></PrimaryLabel>

      <XDivider width='10px' />
      |
      <XDivider width='10px' />
      <PrimaryLabel id={'boxList_button_jobDetails'} onClick={props.onShowJobList} style={props.jobColor ? { color: '#1975bc' } : { color: '#58595b' }}><Label>routeTitles.jobDetails</Label></PrimaryLabel>

      <XDivider width='10px' />
      {props.templateSelected === 'New Box' || props.templateSelected === 'Maintenance Box'
        ? <>|<XDivider width='10px' />{ }
          <PrimaryLabel id={'boxList_button_fileDetails'} onClick={props.onShowFileList} style={props.fileColor ? { color: '#1975bc' } : { color: '#58595b' }}><Label>routeTitles.boxesDetails</Label></PrimaryLabel>
        </>
        : <>|<XDivider width='10px' />{ }
          <PrimaryLabel id={'boxList_button_fileDetails'} onClick={props.onShowFileList} style={props.fileColor ? { color: '#1975bc' } : { color: '#58595b' }}><Label>routeTitles.fileDetails</Label></PrimaryLabel>
        </>
      }
    </>
  )
}

DetailsSubtitle.propTypes = {
  onShowBoxList: PropTypes.func,
  onShowJobList: PropTypes.func,
  onShowFileList: PropTypes.func,
  boxColor: PropTypes.bool,
  jobColor: PropTypes.bool,
  fileColor: PropTypes.bool,
  templateSelected: PropTypes.any
}

const BoxStyle = styled('div')`
    width: 25%; 
    padding-top: 10px;
    padding-left: 10px;
    padding-bottom: 10px;
    background-color: ${props => props.theme.palette.subPageHeaderBackground};
  `

const LableStyle = styled('div')`
    border-right: 1px solid;
  `
// eslint-disable-next-line
const user = getUser()

// const loggedInUserDistrict = user.district
const SELECT_COUNTRY = 0
const SELECT_WMS = 1
const SELECT_DISTRICT = 2
const SELECT_ORDER_NUMBER = 3
const SELECT_ACOUNT_LEVEL1 = 4
const SELECT_ACOUNT_LEVEL2 = 5
const SELECT_ACOUNT_LEVEL3 = 6
const SELECT_ASSET_TYPE = 7
const SELECT_TEMPLATE_NAME = 8
const TOTAL_BOXES = 9
const PICKUP_DATE = 10
const TARGET_DATE = 11
const SKP_INSTANCE = 12


const defaultSelectOption = { value: constants.defaultSelect, label: constants.defaultSelect }

const initialState = {
  isTemplateFieldAdded: false,
  skpInstance: [constants.defaultSelect],
  formTemplate: [],
  showTable: false,
  showPreview: false,
  fieldCount: 12,
  userCount: 1,
  jobIds: [],
  countryList: [],
  jobDetails: {},
  wmsList: [],
  districtList: [],
  templateTypeList: [],
  templateNameList: [],
  orderNumber: [],
  accLevelOneList: [],
  accLevelTwoList: [],
  accLevelThreeList: [],
  templateDetails: [],
  entryUserList: [],
  verifyUserList: [],
  workerList: [],
  totalBoxes: 0,
  pickDate: null,
  targDate: null,
  userList: [],
  translatedStatus: '',
  jobStatus: ''
}

// eslint-disable-next-line
let selectedTemplate = ''

const JobDetailsList = forwardRef((props, ref) => {
  const refLocalBusyCursor = useRef(null)
  const [state, setState, getState] = useMergeState(initialState)
  const refLocalToast = useRef(null)
  const theme = useTheme()
  const location = useLocation()
  const history = useHistory()
  const [disableEdit, setDisableEdit] = useState(false)
  const [allowEditJob, setAllowEditJob] = useState(true)
  const { t } = useTranslation()

  useEffect(() => {
    getJobDetails()
  }, [])

  const formTemplate = [
    {
      label: 'templates.country',
      fieldKey: 'countryCode',
      isRequired: true
    },
    {
      label: 'templates.associatedWMSSystem',
      fieldKey: 'wmsCode',
      isRequired: true
    },
    {
      label: 'templates.district',
      fieldKey: 'districtId',
      isRequired: true
    },
    {
      label: 'templates.orderNumber',
      fieldKey: 'orderNumber',
      isRequired: false
    },
    {
      label: 'templates.accountLevelOne',
      fieldKey: 'accountLevel1',
      isRequired: true
    },
    {
      label: 'templates.accountLevelTwo',
      fieldKey: 'accountLevel2',
    },
    {
      label: 'templates.accountLevelThree',
      fieldKey: 'accountLevel3',
    },
    {
      label: 'templates.templateType',
      fieldKey: 'dataEntryType',
      isRequired: false
    },
    {
      label: 'templates.templateName',
      fieldKey: 'templateName',
      isRequired: false
    },
    {
      label: 'templates.totalBoxes',
      fieldKey: 'totalBoxes',
      defaultValue: '',
      isRequired: true,
      maxLength: 4,
      regx: regx.digitsRegx,
      regxError: regx.digitsRegxError,
    },
    {
      label: 'templates.pickupDate',
      fieldKey: 'pickupDate',
      isRequired: true,
    },
    {
      label: 'templates.targetDate',
      fieldKey: 'targetDate',
      isRequired: true,
    },
    {
      label: 'templates.skpinstance',
      fieldKey: 'skpinstance',
      isRequired: false
    }
  ]

  const [arrRefs, data] = useFormPageHandler({ formTemplate, getService, busyOverride: refLocalBusyCursor })

  const getJobDetails = async () => {
    setBusy()
    const userLoggedInDistrict = getUser().district
    const jobId = location.pathname.split('/')[2]
    const jobDoc = await gdeTransactions.getJobById(jobId)
    const jobDetails = jobDoc.data()
    const statusTranslated = t(`jobStatusObj.${jobDetails.jobStatus}`)
    setDisableEdit(jobDetails.jobStatus === constants.jobStatus.transmitted || jobDetails.jobStatus === constants.jobStatus.cancel || jobDetails.jobStatus === constants.jobStatus.readyToTransmit ? true : null)

    const additionalGivenPermissions = window?.sessionStorage?.getItem('additional-permissions-user')
    if (additionalGivenPermissions !== 'undefined' && additionalGivenPermissions !== undefined && userRoleSupervisor) {
      const additionalPermissionsForUser = JSON.parse(additionalGivenPermissions)
      const indexOfEditJob = additionalPermissionsForUser?.map(object => object?.value)?.indexOf('editJob')

      if (additionalPermissionsForUser[indexOfEditJob]?.enabled) {
        setAllowEditJob(false)
      }                              
    }

    const boxDetails = await gdeTransactions.getBoxesForJob(jobId)
    const countryDoc = await gdeTransactions.getCountryByID(jobDetails.countryCode)
    const countryData = countryDoc.data()
    // const workerCollection = await gdeTransactions.getWorkersWithDistrict(loggedInUserDistrict)
    const workerCollection = await gdeTransactions.getworkersLists(userLoggedInDistrict)
    const workerDropList = [defaultSelectOption]
    const workerList = []
    const dataEntryUser = []
    workerCollection.forEach((doc) => {
      workerDropList.push({
        value: doc.id,
        label: `${doc.data().firstName} ${doc.data().lastName} - ${doc.id.replace(/\d(?=\d{3})/g, '*')}`
      })
      workerList[doc.id] = doc.data()
    })
    const countryList = [{ value: countryDoc.id, label: `${countryDoc.id}-${countryData.countryName}` }]
    const wmsList = [{ value: jobDetails.wmsCode, label: jobDetails.wmsCode }]
    const districtList = [{ value: jobDetails.districtId, label: jobDetails.districtId }]
    const templateTypeList = [{ value: jobDetails.dataEntryType, label: jobDetails.dataEntryType }]
    selectedTemplate = jobDetails.dataEntryType
    const skpInstance = [{ value: jobDetails.skpinstance ? jobDetails.skpinstance : constants.defaultSelect, label: jobDetails.skpinstance ? jobDetails.skpinstance : constants.defaultSelect }]

    const templateNameList = [{
      value: jobDetails.templateName ? jobDetails.templateName : jobDetails.standardTemplateName,
      label: jobDetails.templateName ? jobDetails.templateName : jobDetails.standardTemplateName
    }]
    const orderNumber = [{ value: jobDetails.orderNumber, label: jobDetails.orderNumber }]
    const accLevelOneList = [{ value: jobDetails.accountLevel1.toUpperCase(), label: jobDetails.accountLevel1.toUpperCase() }]
    const accLevelTwoList = [{ value: jobDetails.accountLevel2.toUpperCase(), label: jobDetails.accountLevel2.toUpperCase() }]
    const accLevelThreeList = [{ value: jobDetails.accountLevel3.toUpperCase(), label: jobDetails.accountLevel3.toUpperCase() }]

    arrRefs[TOTAL_BOXES].current.setValue(jobDetails.totalBoxes)

    const pickupDate = moment(jobDetails.pickupDate.seconds, 'X').format('YYYY-MM-DD')
    const targetDate = moment(jobDetails.targetDate.seconds, 'X').format('YYYY-MM-DD')


    let i = 0

    if (jobDetails.assignedUsers !== []) {
      for (const user in jobDetails.assignedUsers) {
        if (jobDetails.assignedUsers[user].jobCategory.includes('Data Entry User')) {
          dataEntryUser[i] = {
            dataEntryUser: user,
            verificationUser: jobDetails.assignedUsers[user].verifyUser
          }
          i++
        }
      }
      setState({ userList: dataEntryUser })
      getFormTemplate()
    }

    setState({
      jobId: jobId,
      jobDetails: jobDetails,
      countryList: countryList,
      wmsList: wmsList,
      districtList: districtList,
      templateTypeList: templateTypeList,
      skpInstance: skpInstance,
      templateNameList: templateNameList,
      orderNumber: orderNumber,
      accLevelOneList: accLevelOneList,
      accLevelTwoList: accLevelTwoList,
      accLevelThreeList: accLevelThreeList,
      entryUserList: workerDropList,
      verifyUserList: workerDropList,
      workerList: workerList,
      totalBoxes: boxDetails.size,
      pickDate: pickupDate,
      targDate: targetDate,
      translatedStatus: statusTranslated
    })

    // setting default values
    arrRefs[SELECT_COUNTRY].current.setValue(countryDoc.id)
    arrRefs[SELECT_WMS].current.setValue(jobDetails.wmsCode)
    arrRefs[SELECT_DISTRICT].current.setValue(jobDetails.districtId)
    arrRefs[SKP_INSTANCE].current.setValue(jobDetails.skpinstance ? jobDetails.skpinstance : constants.defaultSelect)
    arrRefs[SELECT_ASSET_TYPE].current.setValue(jobDetails.dataEntryType)
    arrRefs[SELECT_TEMPLATE_NAME].current.setValue(jobDetails.templateName ? jobDetails.templateName : jobDetails.standardTemplateName)
    arrRefs[SELECT_ACOUNT_LEVEL1].current.setValue(jobDetails.accountLevel1.toUpperCase())
    arrRefs[SELECT_ACOUNT_LEVEL2].current.setValue(jobDetails.accountLevel2.toUpperCase())
    arrRefs[SELECT_ACOUNT_LEVEL3].current.setValue(jobDetails.accountLevel3.toUpperCase())
    arrRefs[PICKUP_DATE].current.setValue(pickupDate)
    arrRefs[TARGET_DATE].current.setValue(targetDate)
    arrRefs[SELECT_ORDER_NUMBER].current.setValue(jobDetails.orderNumber)

    clearBusy()
  }

  const getFormTemplate = () => {
    getState().userList.forEach((elem, key) => {
      formTemplate.push(
        {
          label: 'demo.dataEntryUser',
          fieldKey: `assignedUsers.${key}.dataEntryUser`,
          defaultValue: elem.dataEntryUser,
          isRequired: true,
          disabled: true
        },
        {
          label: 'demo.verificationUser',
          fieldKey: `assignedUsers.${key}.verificationUser`,
          defaultValue: elem.verificationUser,
          isRequired: true,
          disabled: true
        },
      )
      arrRefs.push(createRef())
    })
    setState({ isTemplateFieldAdded: true, formTemplate: formTemplate })
  }

  const getAssignedUserFields = () => {
    const newFormTemplate = getState().formTemplate
    const fields = []
    if (getState().isTemplateFieldAdded) {
      let count = 11
      getState().userList.forEach((elem, key) => {
        const innercount = count + 2
        fields.push(
          <>
            <FlexByRow>
              <HalfScreen>
                <FlexGrowOne>
                  <Select
                    id={'boxList_assignedUserField1'}
                    key={innercount}
                    ref={arrRefs[innercount]}
                    fieldTemplate={newFormTemplate[innercount]}
                    items={state.entryUserList}
                    noTranslateItems={true}
                  />
                </FlexGrowOne>
              </HalfScreen>
              <XDivider width='50px' />
              <HalfScreen>
                <FlexGrowOne>
                  <Select
                    id={'boxList_assignedUserField2'}
                    key={innercount + 1}
                    ref={arrRefs[innercount + 1]}
                    fieldTemplate={newFormTemplate[innercount + 1]}
                    items={state.verifyUserList}
                    noTranslateItems={true}
                  />
                </FlexGrowOne>
              </HalfScreen>
            </FlexByRow>
            <VerticalDivider />
          </>
        )
        count = count + 2
      })
    }
    return fields
  }

  const handleDelete = async (jobId) => {
    const metrics = await gdeTransactions.getJobMetrics(jobId)
    metrics.forEach((doc) => {
      gdeTransactions.deleteJobMetrics(doc.id)
    })
    await gdeTransactions.deleteJob(jobId, getState().jobDetails.dataEntryType, getUser().workerId)
    successToast({ message: t('toast.deleteJobMessage'), title: t('toast.jobManagement') })
    history.goBack()
    closeGeneralDialog()
  }

  // backend data conversion for template types
  state.templateTypeList.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`templateTypeObj.${element.value}`)
    }
  })

  const handleEdit = () => {
    const jobId = getState().jobId
    history.push(`${routePaths.editJob}/${jobId}`)
  }

  const ContentForDeleteBox = (props) => (
    <>
      <Label id={'boxList_deleteButton_deleteContent1'} >Search.DeleteBoxContent1</Label>
      <Label id={'boxList_deleteButton_deleteContent2'} >Search.DeleteBoxContent2</Label>
      <VerticalDivider />
    </>
  )

  const DeleteButtons = (props) => (
    <>
      <VerticalDivider />
      <XDivider width="25px" />
      <OutlinedButton id={'boxList_deleteButton_cancel'} style={{ minWidth }} onClick={() => closeGeneralDialog()} >Search.Cancel</OutlinedButton>
      <ContainedButton id={'boxList_deleteButton_yes'} style={{ minWidth }} onClick={props.handleDelete}>Search.yes</ContainedButton>
      <VerticalDivider />
      <XDivider width="25px" />
    </>
  )

  DeleteButtons.propTypes = {
    handleDelete: PropTypes.func,
  }

  const openDeleteBoxDialog = (jobData) => {
    openGeneralDialog({
      title: t('Search.DeleteJob'),
      noTranslateTitle: true,
      message: <ContentForDeleteBox />,
      closeX: true,
      buttons: (
        <DeleteButtons
          handleDelete={() => handleDelete(getState().jobId)}
        />
      )
    })
    return Promise.resolve()
  }

  const handleCancelButtonOnClick = () => {
    closeGeneralDialog()
    history.goBack()
  }

  const ButtonsForCancelDialogBox = () =>
    <>
      <OutlinedButton id={'boxList_dialogBoxButton_no'} onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton id={'boxList_dialogBoxButton_yes'} onClick={handleCancelButtonOnClick} >buttons.Ok</ContainedButton>
    </>

  const handleCancelButtonClick = () => {
    openGeneralDialog({
      title: t('options.cancelJobTitle'),
      message: t('options.cancelJobMessage'),
      noTranslateTitle: true,
      buttons: <ButtonsForCancelDialogBox />,
      closeX: true
    })
  }

  return (
    <>
      <MainRouteSubRoutePage
        mainTitle='routeTitles.jobManagement'
        subTitle={<><GoBackSubtitle /><DetailsSubtitle onShowBoxList={props.onShowBoxList} onShowJobList={props.onShowJobList} onShowFileList={props.onShowFileList} templateSelected={getState()?.jobDetails?.dataEntryType} jobColor={props.jobColor} /></>}
        buttons={<JobButtons jobStatus={disableEdit} arrRefs={arrRefs} allowEditJob={allowEditJob} onClickEdit={handleEdit} onClickDelete={openDeleteBoxDialog} onClickCancel={handleCancelButtonClick} />}
      >

        <FlexByRow>
          <LocalToast ref={refLocalToast} />
          <BoxStyle theme={theme}>
            <Box>
              <LableStyle><Label>demo.jobID</Label></LableStyle>
              <YDivider />
              <LableStyle>{state.jobId}</LableStyle>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
            <Box>
              <LableStyle><Label>demo.jobStatus</Label></LableStyle>
              <YDivider />
              <LableStyle>{state?.translatedStatus}</LableStyle>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
            <Box>
              <Label>tableColumns.boxesTransmitted</Label>
              <YDivider />
              <Label>{state.jobDetails.boxesCompleted ? state.jobDetails.boxesCompleted : 0}</Label>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
            <Box>
              <Label>editJob.manualTransmit</Label>
              <YDivider />
              <Label><CheckBox checked={!(state.jobDetails.autoTransmit === 'false') ? false : 'true'} disabled={true} /></Label>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
            <Box>
              <Label>editJob.uploadCustomerData</Label>
              <YDivider />
              <Label><CheckBox checked={state?.jobDetails?.isUploadCustomerDataFile} disabled={true} /></Label>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
          </BoxStyle>
        </FlexByRow>
        <VerticalDivider />
        <FlexByRow>
          <HalfScreen>
            <Select
              id={'boxList_countryList'}
              data={data}
              items={state.countryList}
              fieldTemplate={formTemplate[SELECT_COUNTRY]}
              ref={arrRefs[SELECT_COUNTRY]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select
              id={'boxList_wmsList'}
              data={data}
              items={state.wmsList}
              fieldTemplate={formTemplate[SELECT_WMS]}
              ref={arrRefs[SELECT_WMS]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select
              id={'boxList_districtList'}
              data={data}
              items={state.districtList}
              fieldTemplate={formTemplate[SELECT_DISTRICT]}
              ref={arrRefs[SELECT_DISTRICT]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select
              id={'boxList_skpInstance'}
              data={data}
              items={state.skpInstance}
              fieldTemplate={formTemplate[SKP_INSTANCE]}
              ref={arrRefs[SKP_INSTANCE]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <TextField id={'createJob_orderNumber'} data={data} fieldTemplate={formTemplate[SELECT_ORDER_NUMBER]} ref={arrRefs[SELECT_ORDER_NUMBER]} disabled={true} />
            <VerticalDivider />
            <TextField
              id={'boxList_accountLevel1'}
              data={data}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL1]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL1]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
          </HalfScreen>
          <XDivider width='50px' />
          <HalfScreen>
            <TextField
              id={'boxList_accountLevel2'}
              data={data}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL2]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL2]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <TextField
              id={'boxList_accountLevel3'}
              data={data}
              fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL3]}
              ref={arrRefs[SELECT_ACOUNT_LEVEL3]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select
              id={'boxList_templateTypeList'}
              data={data}
              items={state.templateTypeList}
              fieldTemplate={formTemplate[SELECT_ASSET_TYPE]}
              ref={arrRefs[SELECT_ASSET_TYPE]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            <Select
              id={'boxList_templateNameList'}
              data={data}
              items={state.templateNameList}
              fieldTemplate={formTemplate[SELECT_TEMPLATE_NAME]}
              ref={arrRefs[SELECT_TEMPLATE_NAME]}
              noTranslateItems
              disabled={true}
            />
            <VerticalDivider />
            {getState()?.jobDetails?.dataEntryType !== 'Maintenance Box' && getState()?.jobDetails?.dataEntryType !== 'New Box' && getState()?.jobDetails?.dataEntryType !== 'Maintenance File' && getState()?.jobDetails?.dataEntryType !== 'New File' &&
              <>
                <TextField
                  id={'boxList_totalBoxes'}
                  data={data}
                  fieldTemplate={formTemplate[TOTAL_BOXES]}
                  ref={arrRefs[TOTAL_BOXES]}
                  type='number'
                  disabled={true}
                />
                <VerticalDivider />
              </>
            }

            <FlexByRow>
              <FlexGrowOne>
                <DateTime
                  id={'boxList_pickDate'}
                  data={data}
                  fieldTemplate={formTemplate[PICKUP_DATE]}
                  ref={arrRefs[PICKUP_DATE]}
                  type='date'
                  minDate={today()}
                  disabled={true}
                />
              </FlexGrowOne>
              <XDivider width='20px' />
              <FlexGrowOne>
                <DateTime
                  id={'boxList_targetDate'}
                  data={data}
                  fieldTemplate={formTemplate[TARGET_DATE]}
                  ref={arrRefs[TARGET_DATE]}
                  type='date'
                  minDate={sameDayNextMonth()}
                  disabled={true}
                />
              </FlexGrowOne>
            </FlexByRow>
            <VerticalDivider />
            <VerticalDivider />
          </HalfScreen>
        </FlexByRow>
        {getAssignedUserFields()}
        <XDivider width='20px' />
      </MainRouteSubRoutePage>
    </>
  )
})


const initialSate = {
  showTable: false,
  boxes: [],
  jobDoc: '',
  boxUserList: [],
  jobUserData: {},
  isNewBoxDisable: false,
  workerList: {}
}

const BoxesList = forwardRef((props, ref) => {
  const user = getUser()
  const loggedInUser = user.workerId
  const history = useHistory()
  const location = useLocation()
  const jobId = location.pathname.split('/')[2]
  const theme = useTheme()
  const classes = useStyles()
  const SEARCH_FIELD = 0
  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
  })
  const [state, setState, getState] = useMergeState(initialSate)
  const [TextValue, setTextValue] = useState(null)
  const [hideFilesKeyed, setHideFilesKeyed] = useState(false)
  const [Refresh, setRefresh] = useState(false)
  const { t } = useTranslation()


  useEffect(async () => {
    setBusy()
    await getJobDetails()
    await getJobTemplate()
    clearBusy()
  }, [])

  const getJobTemplate = async () => {
    setBusy()
    const jobDocument = await gdeTransactions.getJobById(jobId)
    const jobDoc = jobDocument.data()
    const jobCountryCode = jobDoc?.countryCode
    const userRole = user?.userRolesObj?.gdeRole

    if (history.action === 'PUSH') {
      setState({ allowAccessToBoxlist: true })
    }
    
    if (history.action === 'POP') {
      if (userRole !== 'Super User') {
        const userCountryCode = user.countryCode
        const userAlternateCountryCode = user.alternateCountryCode
        if (jobCountryCode === userCountryCode || jobCountryCode === userAlternateCountryCode) {
          setState({ allowAccessToBoxlist: true })
        } else {
          setState({ allowAccessToBoxlist: false })
        }
      } else {
        const userCountryCode = user.countryCode
        const userAlternateCountryCode = user.alternateCountryCode
        if (jobCountryCode === userCountryCode || jobCountryCode === userAlternateCountryCode) {
          setState({ allowAccessToBoxlist: true })
        } else {
          const countryDoc = await gdeTransactions.getCountryByID(jobCountryCode)
          const countryData = countryDoc.data()
          const jobCountry = countryData?.countryName
          const userCountries = user?.userRolesObj?.country
          if (userCountries.includes(jobCountry)) {
            setState({ allowAccessToBoxlist: true })
          } else {
            setState({ allowAccessToBoxlist: false })
          }
        }
      }
    }

    const templateName = jobDoc.standardTemplateName
    if (templateName === 'skpStandardNewFile' || templateName === 'skpStandardMaintenanceFile') {
      setHideFilesKeyed(false)
    } else {
      setHideFilesKeyed(true)
    }
    clearBusy()
  }
  const checkUserRole = (rowData) => {
    let isDisable = true

    const userType = getUserType(getState().jobUserData, loggedInUser, rowData)

    if ((rowData.status1 === constants.boxStatus.dataEntryInProcess && userType === userTypes.DATAENTRY_USER) ||
      (rowData.status1 === constants.boxStatus.dataEntryInProcess && userType === userTypes.DATAENTRY_AND_VERIFY_USER)) {
      isDisable = false
    } else if ((rowData.status1 === constants.boxStatus.readyForVerification && userType === userTypes.VERIFICATION_USER) ||
      (rowData.status1 === constants.boxStatus.verificationInProcess && userType === userTypes.VERIFICATION_USER)) {
      isDisable = false
    } else if ((rowData.status1 === constants.boxStatus.readyForVerification && userType === userTypes.DATAENTRY_AND_VERIFY_USER) ||
      (rowData.status1 === constants.boxStatus.verificationInProcess && userType === userTypes.DATAENTRY_AND_VERIFY_USER)) {
      isDisable = false
    } else if ((rowData.status1 === constants.boxStatus.requiresReKey && userType === userTypes.DATAENTRY_USER) ||
      (rowData.status1 === constants.boxStatus.requiresReKey && userType === userTypes.DATAENTRY_AND_VERIFY_USER)) {
      isDisable = false
    }

    return isDisable
  }

  const columns = [
    {
      title: t('tableColumns.skpBoxId'),
      field: 'boxId',
      headerAlign: 'center',
      editable: 'never',
      render: (rowdata) => {
        const userType = getUserType(getState().jobUserData, loggedInUser, rowdata)
        if (rowdata.status1 === constants.boxStatus.transmitted && (getState()?.jobDetails?.dataEntryType === 'Maintenance File' || getState()?.jobDetails?.dataEntryType === 'New File')
        ) {
          return (
            <BoxLink theme={theme} className={''} to={`${routePaths.dataEntry}/${jobId}/${rowdata.boxId}/ViewAllFiles`}>
              {rowdata.boxId}
            </BoxLink>
          )
        } else if (rowdata.status1 === constants.boxStatus.readyForQc ||
          rowdata.status1 === constants.boxStatus.approved ||
          rowdata.status1 === constants.boxStatus.qcInProcess ||
          rowdata.status1 === constants.boxStatus.exception ||
          checkUserRole(rowdata)) {
          return (
            <BoxLink theme={theme} className={classes.disabledState} to={`${routePaths.dataEntry}/${jobId}/${rowdata.boxId}`}>
              {rowdata.boxId}
            </BoxLink>
          )
        } else {
          return (
            <a onClick={() => onStartDataEntry(jobId, rowdata.boxId, userType)} style={{ color: 'blue' }}>{rowdata.boxId}</a>
          )
        }
      },
    },
    {
      title: t('tableColumns.entryUser'),
      field: 'entryUser',
      headerAlign: 'center',
      sortable: true,
      editable: 'never'
    },
    {
      title: t('tableColumns.fileKeyed'),
      field: 'fileKeyed',
      headerAlign: 'center',
      sortable: false,
      editable: 'never',
      hidden: hideFilesKeyed
    },
    {
      title: t('tableColumns.lastStatusChange'),
      field: 'actionTs',
      headerAlign: 'center',
      sortable: true,
      editable: 'never'
    },
    {
      title: t('tableColumns.status'),
      field: 'status',
      headerAlign: 'center',
      sortable: false,
      editable: 'never'
    },
    {
      title: t('tableColumns.fileId'),
      field: 'fileId',
      headerAlign: 'center',
      sortable: false,
      editable: 'never'
    }
  ]

  if (getState().showButtons && (getState()?.jobDetails?.dataEntryType === 'Maintenance File' || getState()?.jobDetails?.dataEntryType === 'New File')) {
    columns.push({
      title: t('tableColumns.action'),
      field: 'status',
      headerAlign: 'center',
      sortable: false,
      editable: 'never',
      render: (rowdata) => {
        if (rowdata.status1 === constants.boxStatus.approved ||
          rowdata.status1 === constants.boxStatus.dataEntryComplete ||
          rowdata.status1 === constants.boxStatus.readyForVerification ||
          rowdata.status1 === constants.boxStatus.readyForQc) {
          return (
            <BottomPaddedButton id={'dataEntry_button_handleCancel'} disabled={props.isAddNewFileByQc} onClick={() => onChangeBoxStatToDataEntry(jobId, rowdata.boxId, constants.boxStatus.dataEntryInProcess)} variant='outlined' color='primary' arrRefs={props.arrRefs}>tableColumns.startDataEntry</BottomPaddedButton>
          )
        }
      }
    })
  }

  if (!location?.state?.fromAdmin && location?.state?.fromAdmin !== undefined && !(getUserType(getState()?.jobDetails?.assignedUsers[loggedInUser]) === userTypes.VERIFICATION_USER) && (getState()?.jobDetails?.jobStatus === constants.jobStatus.transmitted || (getState()?.jobDetails?.boxLevelRetransmit === true && getState()?.jobDetails?.jobStatus !== constants.jobStatus.transmitted))) {
    columns.push({
      title: t('tableColumns.actionRetransmit'),
      field: 'status',
      headerAlign: 'center',
      sortable: false,
      editable: 'never',
      render: (rowdata) => {
        if (rowdata.status1 === constants.boxStatus.transmitted) {
          return (
            <BottomPaddedButton id={'dataEntry_button_handleCancel'} disabled={props.isAddNewFileByQc} onClick={() => onRetransmitBox(jobId, rowdata.boxId, constants.boxStatus.dataEntryInProcess)} variant='outlined' color='primary' arrRefs={props.arrRefs}>tableColumns.startDataEntry</BottomPaddedButton>
          )
        }
      }
    })
  } else if (!(getUserType(getState()?.jobDetails?.assignedUsers[loggedInUser]) === userTypes.VERIFICATION_USER) && (getState()?.jobDetails?.jobStatus === constants.jobStatus.transmitted || (getState()?.jobDetails?.boxLevelRetransmit === true && getState()?.jobDetails?.jobStatus !== constants.jobStatus.transmitted))) {
    const loggedInUserGdeRole = getUserRole()
    const isAdminOrSuperUser = loggedInUserGdeRole === userRoleAdmin || loggedInUserGdeRole === userRoleSuperUser
    if (isAdminOrSuperUser) {
      columns.push({
        title: t('tableColumns.actionRetransmit'),
        field: 'status',
        headerAlign: 'center',
        sortable: false,
        editable: 'never',
        render: (rowdata) => {
          if (rowdata.status1 === constants.boxStatus.transmitted) {
            if (isAdminOrSuperUser) {
              return (
                <BottomPaddedButton id={'boxList_directRetransmit'} disabled={props.isAddNewFileByQc} onClick={() => onDirectRetransmitBox(jobId, rowdata.boxId)} variant='outlined' color='primary' arrRefs={props.arrRefs} noTranslate>demo.reTransmit</BottomPaddedButton>
              )
            }
          }
        }
      })
    }
  }

  const onDirectRetransmitBox = (jobId, boxId) => {
    openGeneralDialog({
      title: t('dataEntry.changeBoxStatusToRetransmit'),
      noTranslateTitle: true,
      message: t('dataEntry.reTransmitBoxMsg'),
      translateMessage: false,
      buttons: (
        <ButtonsForDirectRetransmitBox handleDirectRetransmitBox={() => handleDirectRetransmitBox(jobId, boxId)} />
      ),
      closeX: true
    })
  }

  const ButtonsForDirectRetransmitBox = (props) => (
    <>
      <OutlinedButton id={'boxList_directRetransmit_no'} onClick={closeGeneralDialog}>buttons.no</OutlinedButton>
      <XDivider width='10px' />
      <ContainedButton id={'boxList_directRetransmit_yes'} onClick={props.handleDirectRetransmitBox}>buttons.yes</ContainedButton>
    </>
  )

  ButtonsForDirectRetransmitBox.propTypes = {
    handleDirectRetransmitBox: PropTypes.func
  }

  const handleDirectRetransmitBox = async (jobId, boxId) => {
    setBusy()
    const rawJobByIdData = await gdeTransactions.getJobById(jobId)
    const jobData = rawJobByIdData.data()

    const jobUpdateData = {
      actionTs: new Date(),
      boxLevelRetransmit: true,
      jobStatus: constants.jobStatus.readyToTransmit,
      boxesCompleted: --jobData.boxesCompleted,
      autoTransmit: 'true',
      autoTransmitAndStatus: `true-${constants.jobStatus.readyToTransmit}`,
    }
    await gdeTransactions.updateJob(jobId, jobUpdateData)

    const boxData = {
      actionTs: new Date(),
      retransmittedTs: new Date(),
      retransmitted: true,
      status: constants.boxStatus.approved,
      fileId: '',
      transmissionStatus: constants.boxTransmissionStatus.pending,
      transmissionStatusTs: new Date(),
    }

    const retransmitMetricData = {
      activityType: constants.retransmitAction,
      jobId: jobId,
      boxId: boxId
    }

    await gdeTransactions.updateBoxData(jobId, boxId, boxData)

    const jobMetricsData = await gdeTransactions.getJobMetrics(jobId, false)
    jobMetricsData.forEach((doc) => {
      const data = doc.data()
      const { metricsFileId, activityType } = data
      if (metricsFileId !== undefined && activityType !== 'retransmit') {
        const metricsData = {
          jobOrderNumber: jobData.orderNumber,
          jobLastModifyTs: new Date(),
          updatedTs: new Date(),
        }
        gdeTransactions.updateMetricsForJobBox(doc.id, metricsData)
      }
    })
    await gdeTransactions.saveMetricsData(retransmitMetricData)

    successToast({ message: t('toast.reTransmitQueued', { jobId: jobId }) })
    await getJobDetails()
    setRefresh(prev => !prev)
    clearBusy()
    closeGeneralDialog()
  }

  const onRetransmitBox = async (jobId, boxId, newBoxStatus) => {
    openGeneralDialog({
      title: t('dataEntry.changeBoxStatusToRetransmit'),
      noTranslateTitle: true,
      message: t('dataEntry.changeBoxStatusToRetransmitMsg'),
      buttons: (
        <ButtonsForRetransmitBox handleOnRetransmitBox={() => handleOnRetransmitBox(jobId, boxId, newBoxStatus)} />
      ),
      closeX: true
    })
  }

  const ButtonsForRetransmitBox = (props) => (
    <>
      <OutlinedButton id={'dataEntry_button_ButtonsForCancelDialogBoxNo'} onClick={closeGeneralDialog}>buttons.no</OutlinedButton>
      <XDivider width='10px' />
      <ContainedButton id={'dataEntry_button_ButtonsForCancelDialogBoxYes'} onClick={props.handleOnRetransmitBox}>buttons.yes</ContainedButton>
    </>
  )

  ButtonsForRetransmitBox.propTypes = {
    handleOnRetransmitBox: PropTypes.func
  }

  const handleOnRetransmitBox = async (jobId, boxId, newBoxStatus) => {
    setBusy()
    const rawJobByIdData = await gdeTransactions.getJobById(jobId)
    const jobData = rawJobByIdData.data()

    const data = {
      actionTs: new Date(),
      boxLevelRetransmit: true,
      boxesCompleted: --jobData.boxesCompleted,
      jobStatus: constants.jobStatus.inProgress,
      autoTransmit: 'true',
      autoTransmitAndStatus: `${true}-${constants.jobStatus.inProgress}`,
    }
    await gdeTransactions.updateJob(jobId, data)

    const boxData = {
      actionTs: new Date(),
      retransmittedTs: new Date(),
      retransmitted: true,
      status: newBoxStatus,
      transmissionStatus: constants.boxTransmissionStatus.pending,
      transmissionStatusTs: new Date(),
    }

    const retransmitMetricData = {
      activityType: constants.retransmitAction,
      jobId: jobId,
      boxId: boxId
    }

    await gdeTransactions.updateBoxData(jobId, boxId, boxData)
    const jobBoxMetricsData = await gdeTransactions.getMetricsForJobBox(jobId, boxId)
    jobBoxMetricsData.forEach((doc) => {
      const data = doc.data()
      const { metricsFileId, totalBoxCount } = data
      if (metricsFileId !== undefined) {
        const metricsData = {
          totalRecordCount: 0,
          totalBoxCount: 0,
          updatedTs: new Date(),
        }
        totalBoxCount > 0 && gdeTransactions.updateMetricsForJobBox(doc.id, metricsData)
      }
    })

    // code to update job last modify date in gdeMetrics collection 
    const jobMetricsData = await gdeTransactions.getJobMetrics(jobId, false)
    jobMetricsData.forEach((doc) => {
      const data = doc.data()
      const { metricsFileId, activityType } = data
      if (metricsFileId !== undefined && activityType !== 'retransmit') {
        const metricsData = {
          jobOrderNumber: jobData.orderNumber,
          jobLastModifyTs: new Date(),
          updatedTs: new Date(),
        }
        gdeTransactions.updateMetricsForJobBox(doc.id, metricsData)
      }
    })
    await gdeTransactions.saveMetricsData(retransmitMetricData)

    setTimeout(history.push(`${routePaths.dataEntry}/${jobId}/${boxId}`), 5000)
    clearBusy()
    closeGeneralDialog()
  }

  const onChangeBoxStatToDataEntry = async (jobId, boxId, newBoxStatus) => {
    openGeneralDialog({
      title: t('dataEntry.continuedataEntry'),
      noTranslateTitle: true,
      message: t('dataEntry.changeBoxStatusMsg'),
      buttons: (
        <ButtonsForCancelDialogBox handleOnChangeBoxStatToDataEntry={() => handleOnChangeBoxStatToDataEntry(jobId, boxId, newBoxStatus)} />
      ),
      closeX: true
    })
  }

  const ButtonsForCancelDialogBox = (props) => (
    <>
      <OutlinedButton id={'dataEntry_button_ButtonsForCancelDialogBoxNo'} onClick={closeGeneralDialog}>buttons.no</OutlinedButton>
      <XDivider width='10px' />
      <ContainedButton id={'dataEntry_button_ButtonsForCancelDialogBoxYes'} onClick={props.handleOnChangeBoxStatToDataEntry}>buttons.yes</ContainedButton>
    </>
  )

  ButtonsForCancelDialogBox.propTypes = {
    handleOnChangeBoxStatToDataEntry: PropTypes.func
  }

  const handleOnChangeBoxStatToDataEntry = async (jobId, boxId, newBoxStatus) => {
    const box = await gdeTransactions.getBox(jobId, boxId)
    const boxStatus = box.data().status
    if (boxStatus === constants.boxStatus.transmitted) {
      handleOnRetransmitBox(jobId, boxId, newBoxStatus)
    } else {
      setBusy()
      const boxData = {
        actionTs: new Date(),
        boxEditedTs: new Date(),
        boxEdited: true,
        status: newBoxStatus,
        transmissionStatus: constants.boxTransmissionStatus.pending,
        transmissionStatusTs: new Date(),
      }
      await gdeTransactions.updateBoxData(jobId, boxId, boxData)

      const jobBoxMetricsData = await gdeTransactions.getMetricsForJobBox(jobId, boxId)
      jobBoxMetricsData.forEach((doc) => {
        const data = doc.data()
        const { metricsFileId, totalBoxCount } = data
        if (metricsFileId !== undefined) {
          const metricsData = {
            totalRecordCount: 0,
            totalBoxCount: 0,
            updatedTs: new Date(),
          }
          totalBoxCount > 0 && gdeTransactions.updateMetricsForJobBox(doc.id, metricsData)
        }
      })

      setTimeout(history.push(`${routePaths.dataEntry}/${jobId}/${boxId}`), 5000)
      clearBusy()
      closeGeneralDialog()
    }
  }

  const onStartDataEntry = async (jobId, boxId, userType) => {
    setBusy()
    if (userType === userTypes.DATAENTRY_USER || userType === userTypes.DATAENTRY_AND_VERIFY_USER) {
      const jobBoxMetricsData = await gdeTransactions.getMetricsForJobBox(jobId, boxId)
      jobBoxMetricsData.forEach((doc) => {
        const data = doc.data()
        const { metricsFileId, totalBoxCount } = data
        if (metricsFileId !== undefined) {
          const metricsData = {
            totalRecordCount: 0,
            totalBoxCount: 0,
            updatedTs: new Date(),
          }
          totalBoxCount > 0 && gdeTransactions.updateMetricsForJobBox(doc.id, metricsData)
        }
      })
    }
    setTimeout(history.push(`${routePaths.dataEntry}/${jobId}/${boxId}`), 5000)
    clearBusy()
    closeGeneralDialog()
  }

  const handleCancel = () => {
    history.goBack()
  }

  const handleJobComplete = async () => {
    let isBoxInfoMissing = false
    const boxData = {
      actionTs: new Date(),
      status: constants.boxStatus.dataEntryInProcess,
    }
    if (getState()?.jobDetails?.dataEntryType === 'New Box' || getState()?.jobDetails?.dataEntryType === 'Maintenance Box') {
      const collectionBoxes = await gdeTransactions.getBoxesForJob(getState().jobDetails.jobId)
      collectionBoxes.forEach((doc) => {
        if (doc.data().boxInfo === undefined) {
          isBoxInfoMissing = true
          gdeTransactions.updateBoxData(getState().jobDetails.jobId, doc.data().boxId, boxData)
        }
      })
    }

    if (isBoxInfoMissing) {
      openGeneralDialog({
        title: t('dataEntry.IncompleteBoxes'),
        noTranslateTitle: true,
        message: <Label>dataEntry.IncompleteMsgBoxList</Label>,
        buttons: (
          <ButtonForIncompleteBoxesmsg />
        ),
        closeX: true
      })
      setRefresh(true)
    } else {
      let bc = 0
      for (let i = getState().boxes.length - 1; i >= 0; i--) {
        // if (getState().boxes[i].status === constants.boxStatus.readyForQc || getState().boxes[i].status === constants.boxStatus.transmitted || getState().boxes[i].status === constants.boxStatus.readyForVerification || getState().boxes[i].status === constants.boxStatus.exception || getState().boxes[i].status === constants.boxStatus.approved || getState().boxes[i].status === constants.boxStatus.requiresReKey) {
        if (getState().boxes[i].status !== constants.boxStatus.dataEntryInProcess) {
          bc = bc + 0
        } else {
          bc = bc + 1
        }
      }
      if (getState().currentBoxCount >= 1 && bc === 0) {
        openGeneralDialog({
          title: t('dataEntry.jobComplete'),
          noTranslateTitle: true,
          message: <Label>dataEntry.jobCompleteMsg</Label>,
          buttons: (
            <ButtonsForTransmitDialogBox />
          ),
          closeX: true
        })
      } else {
        if (getState().currentBoxCount === 0) {
          openGeneralDialog({
            title: t('dataEntry.alert'),
            noTranslateTitle: true,
            message: <Label>dataEntry.AlertMsg</Label>,
            buttons: (
              <ButtonForAlertmsg />
            ),
            closeX: true
          })
        } else {
          openGeneralDialog({
            title: t('dataEntry.IncompleteBoxes'),
            noTranslateTitle: true,
            message: <Label>dataEntry.IncompleteMsgBoxList</Label>,
            buttons: (
              <ButtonForIncompleteBoxesmsg />
            ),
            closeX: true
          })
        }
      }
    }
  }

  const ButtonsForTransmitDialogBox = () =>
    <>
      <OutlinedButton id={'boxList_dialogBoxButton_no'} onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton id={'boxList_dialogBoxButton_yes'} onClick={handleTotalBoxes} autoFocus>buttons.yes</ContainedButton>
    </>

  const ButtonForAlertmsg = () =>
    <>
      <ContainedButton id={'boxList_dialogBoxButton_yes'} onClick={closeGeneralDialog} autoFocus>buttons.Ok</ContainedButton>
    </>
  const ButtonForIncompleteBoxesmsg = () =>
    <>
      <ContainedButton id={'boxList_dialogBoxButton_yes'} onClick={closeGeneralDialog} autoFocus>buttons.Ok</ContainedButton>
    </>


  const handleTotalBoxes = async () => {
    const JobState = getState().jobDetails.jobId
    const collection = await gdeTransactions.getBoxesForJob(JobState)
    const jobCompleteBoxCount = collection.size
    const data = {
      totalBoxes: jobCompleteBoxCount,
    }
    getState().jobDetails.totalBoxes = jobCompleteBoxCount
    await gdeTransactions.updateJob(JobState, data)
    setTimeout(() => {
      history.push(`${routePaths.myJobs}`)
    }, 1000)
    closeGeneralDialog()
    successToast({ message: t('toast.jobSubmitted') })
    await statusUpdateForJob()
  }

  const statusUpdateForJob = async (userType) => {
    const collection = await gdeTransactions.getBoxesForJob(jobId)

    const boxes = Object.values(collection.docs).sort(function (a, b) {
      const boxSrNoA = a.data().boxSrNo || a.data().boxId
      const boxSrNoB = b.data().boxSrNo || b.data().boxId
      return boxSrNoA > boxSrNoB ? 1 : -1
    }).slice(0)

    const boxList = []
    const boxUserList = []

    boxes.forEach((doc) => {
      const data = doc.data()
      boxList.push({
        boxId: data.boxId,
        entryUser: data.dataEntryUser,
        status: data.status,
        status1: data.status,
        dataEntryUser: data.dataEntryUser,
        verificationUser: data.verificationUser
      })
      boxUserList.push(doc.data().dataEntryUser)
    })
    const checkReadyToTransmit = (Boxes) => {
      if (Boxes.status === constants.boxStatus.approved) {
        return Boxes.status === constants.boxStatus.approved
      }
      if (Boxes.status === constants.boxStatus.transmitted) {
        return Boxes.status === constants.boxStatus.transmitted
      }
      if (Boxes.status === constants.boxStatus.exception) {
        return Boxes.status === constants.boxStatus.exception
      }
    }
    const result = boxList.filter(checkReadyToTransmit)

    const transmitBoxEqual = boxList.length === 0 ? false : getState().jobDetails.totalBoxes === result.length

    if (transmitBoxEqual === true && getState().jobDetails.totalBoxes !== 9999) {
      const data = {
        jobStatus: constants.jobStatus.readyToTransmit,
        autoTransmitAndStatus: `${getState().jobDetails.autoTransmit}-${constants.jobStatus.readyToTransmit}`,
      }
      gdeTransactions.updateJob(jobId, data)
    }
  }

  const getBoxes = async () => {
    setBusy()
    const collection = await gdeTransactions.getBoxesForJob(jobId)

    const boxes = Object.values(collection.docs).sort(function (a, b) {
      const boxSrNoA = a.data().boxSrNo || a.data().boxId
      const boxSrNoB = b.data().boxSrNo || b.data().boxId
      return boxSrNoA > boxSrNoB ? 1 : -1
    }).slice(0)

    const boxList = []
    const boxListWithFilesKeyed = []
    const boxUserList = []

    boxes.forEach((doc) => {
      const data = doc.data()
      boxList.push({
        boxId: data.boxId,
        actionTs: moment(data?.actionTs?.toDate()).format(defaultDateFormat),
        entryUser: data.dataEntryUser,
        status: data.status,
        status1: data.status,
        dataEntryUser: data.dataEntryUser,
        fileId: data?.fileId ? data?.fileId : '-',
        verificationUser: data.verificationUser,
        totalFiles: data?.totalFiles
      })
      boxUserList.push(doc.data().dataEntryUser)
    })

    const cachedWorkerList = getState().workerList || {}
    const userIdsToFetch = [...new Set(boxList
      .map(box => box?.entryUser)
      .filter(userId => userId && !cachedWorkerList[userId]))]

    const fetchedWorkerList = {}
    if (userIdsToFetch.length > 0) {
      const userRequests = []
      const userChunkSize = 10
      for (let index = 0; index < userIdsToFetch.length; index += userChunkSize) {
        userRequests.push(gdeTransactions.getUserList(userIdsToFetch.slice(index, index + userChunkSize)))
      }

      const userResults = await Promise.all(userRequests)
      userResults.forEach((userCollection) => {
        userCollection.forEach((doc) => {
          fetchedWorkerList[doc.id] = doc.data()
        })
      })
    }

    const workerList = {
      ...cachedWorkerList,
      ...fetchedWorkerList
    }

    const boxServices = []
    for (const box of boxList) {
      boxServices.push(
        box?.totalFiles !== undefined && box?.totalFiles !== null
          ? Promise.resolve(box.totalFiles)
          : gdeTransactions.syncBoxTotalFiles(jobId, box?.boxId)
      )
    }

    // Prefer the stored totalFiles value and save the fallback count for older box docs.
    const boxResults = await Promise.all(boxServices)

    boxResults.forEach((totalFiles, index) => {
      const user = workerList[boxList[index]?.entryUser]
      const firstName = user?.firstName || ''
      const lastName = user?.lastName || ''
      const userName = `${firstName} ${lastName}`.trim() || boxList[index]?.entryUser
      const boxDetails = { ...boxList[index], entryUser: userName }
      boxDetails.fileKeyed = totalFiles || 0
      boxListWithFilesKeyed.push(boxDetails)
    })

    setState({ boxes: boxListWithFilesKeyed, boxUserList: boxUserList, currentBoxCount: boxListWithFilesKeyed.length, workerList: workerList })
    clearBusy()
    return boxListWithFilesKeyed
  }

  const handleSearchText = (value) => {
    setTextValue(value)
  }


  const showButtons = (jobDetails) => {
    let isShowButton = false
    if ((jobDetails.jobStatus === constants.jobStatus.assigned || jobDetails.jobStatus === constants.jobStatus.inProgress) &&
      jobDetails.assignedUsers[loggedInUser] !== undefined &&
      !(getUserType(jobDetails.assignedUsers[loggedInUser]) === userTypes.VERIFICATION_USER) && !location.state?.fromAdmin) {
      isShowButton = true
    }
    return isShowButton
  }

  const handleOkOnUploadMissing = () => {
    closeGeneralDialog()
    history.goBack()
  }

  const ButtonsForMissingUpload = () =>
    <>
      <ContainedButton id={'boxList_dialogBoxButton_yes'} onClick={handleOkOnUploadMissing} >buttons.Ok</ContainedButton>
    </>

  const handleMissingUpload = () => {
    openGeneralDialog({
      title: t('options.missingUploadData'),
      noTranslateTitle: true,
      message: t('options.missingUploadDataMsg'),
      buttons: <ButtonsForMissingUpload />,
      closeX: false
    })
  }

  const getJobDetails = async () => {
    const job = await gdeTransactions.getJobById(jobId)
    const collection = await gdeTransactions.getBoxesForJob(jobId)

    const jobDetails = job.data()

    // #340 : code to check data is uploaded or not?
    if (jobDetails?.isUploadCustomerDataFile === true && (jobDetails?.uniqueFieldKeyToUploadData === '' || jobDetails?.uniqueFieldKeyToUploadData === undefined)) {
      handleMissingUpload()
    }

    let boxCount = 0
    let flag = false

    collection.forEach((doc) => {
      boxCount++
    })

    if (parseInt(jobDetails.totalBoxes) === boxCount || jobDetails.totalBoxes < boxCount) {
      flag = true
    }

    const jobUserData = jobDetails.assignedUsers[loggedInUser]
    setState({ jobDetails: jobDetails, showButtons: showButtons(jobDetails), jobUserData: jobUserData, isNewBoxDisable: flag })
  }

  return (
    <> {(getState().allowAccessToBoxlist === true)
      ? <MainRouteSubRoutePage
          mainTitle='routeTitles.jobManagement'
          subTitle={<><GoBackSubtitle id={'boxList_goBack'}
        /><DetailsSubtitle templateSelected={getState()?.jobDetails?.dataEntryType} onShowJobList={props.onShowJobList} onShowFileList={props.onShowFileList} onShowBoxList={props.onShowBoxList} boxColor={props.boxColor} /></>}
          buttons={<Buttons onClickCancel={handleCancel} handleJobComplete={handleJobComplete} showButtons={state.showButtons} jobId={jobId} history={history} templateSelected={getState()?.jobDetails?.dataEntryType} disabled={state.isNewBoxDisable} />}
      >
        <FlexByRow>
          <HalfScreen>
          </HalfScreen>
          <HalfScreen>
            <SearchContainer>
              <SearchTextContainer>
                <TextField
                  id={'boxList_search'}
                  onChange={handleSearchText}
                  data={data}
                  fieldTemplate={formTemplate[SEARCH_FIELD]}
                  ref={arrRefs[SEARCH_FIELD]}
                  endAdornment={
                    <InputAdornment position='end'>
                      <SearchIcon />
                    </InputAdornment>
                  }
                />
              </SearchTextContainer>
            </SearchContainer>
          </HalfScreen>
          <VerticalDivider />
        </FlexByRow>
        <XDivider width='18px' />
        <BoxTable columns={columns} getPageData={getBoxes} DataSearch={TextValue} refresh={Refresh} />
        <VerticalDivider />
        <VerticalDivider />
      </MainRouteSubRoutePage>
      : <>{getState().allowAccessToBoxlist === false && <ErrorPage allowAccess={true} />}</>
    }
    </>
  )
})

const initialSlate = {
  fileList: [],
  boxList: [],
  showTable: false,
  boxes: [],
  columnsList: [],
  jobDoc: '',
  boxListWithStatus: [],
  allowAccessToBoxlist: true,
  regexFormat: '',
  filesLoading: false,
  templateName: '',
  jobDetails: {},
}

const buildFileDetailsColumns = (jobDoc, jobId, regexFormat, getState) => {
  const templateType = jobDoc.dataEntryType
  const columnList = [{
    title: translate('tableColumns.srNo'),
    field: 'Sr_No',
    headerAlign: 'center',
    sortable: true,
    editable: 'never',
  }]

  let templateFields = jobDoc.templateData.templateFields
  templateFields = Object.keys(templateFields).map((key) => {
    const data = templateFields[key]
    data.name = key
    return data
  })
  templateFields.sort((a, b) => (a.customOrder > b.customOrder) ? 1 : ((b.customOrder > a.customOrder) ? -1 : 0))

  templateFields.forEach((element) => {
    const includeField = (element.isSelected && element.name !== CUSTOMER_ID && element.name !== MAINTENANCE_CODE) || (element.isSelected && element.name !== CUSTOMER_ID && element.name !== MAINTENANCE_CODE && templateType !== 'Maintenance File' && templateType !== 'New File')

    if (includeField) {
      columnList.push({
        title: element.customName ? element.customName : element.name,
        field: element.name,
        headerAlign: 'center',
        sortable: true,
        editable: element.name === SKP_BOX_ID ? 'never' : 'always',
        doNotDuplicate: element.doNotDuplicate,
        validate: (rowData) => {
          const errors = getValidations(
            element,
            rowData,
            jobId,
            getState()?.fileList,
            getState()?.jobDetails?.skpinstance,
            regexFormat
          )
          return errors.length >= 1 && errors[0] !== undefined ? { isValid: false, helperText: errors[0] } : true
        },
      })
    }
  })

  const templateName = jobDoc.templateName ? jobDoc.templateName : jobDoc.standardTemplateName
  return { columnList, templateName, templateType, templateFields }
}

const getTransmittedBoxIds = async (jobId, jobStatus) => {
  const boxListWithStatus = []
  if (jobStatus === constants.jobStatus.readyToTransmit || jobStatus === constants.jobStatus.transmitted) {
    return boxListWithStatus
  }
  const collection = await gdeTransactions.getBoxesForJob(jobId)
  collection.forEach((doc) => {
    if (doc.data().status === constants.boxStatus.transmitted) {
      boxListWithStatus.push(doc.data().boxId)
    }
  })
  return boxListWithStatus
}

const fetchAllFilesForJob = async (jobId) => {
  const collection = await gdeTransactions.getBoxesForJob(jobId)
  const boxList = collection.docs.map((doc) => ({ SKP_Box_ID: doc.id }))
  const boxes = [...collection.docs].sort((a, b) => {
    const boxSrNoA = a.data().boxSrNo || a.data().boxId
    const boxSrNoB = b.data().boxSrNo || b.data().boxId
    return boxSrNoA > boxSrNoB ? 1 : -1
  })

  const fileChunks = await Promise.all(boxes.map((doc) =>
    gdeTransactions.getFilesForBox(jobId, doc.id).then((collectionFiles) => {
      const files = []
      collectionFiles.forEach((fileDoc) => {
        const file = fileDoc.data().fileInfo
        file.skpBoxId = file.skpBoxId || doc.id
        file.fileId = file.fileId || fileDoc.id
        files.push(file)
      })
      return files
    })
  ))

  let srNo = 1
  const fileList = fileChunks.flat().map((file) => {
    file.Sr_No = srNo++
    return file
  })
  return { fileList, boxList }
}

const fetchBoxRecordsForJob = async (jobId) => {
  const collectionBoxes = await gdeTransactions.getBoxesForJob(jobId)
  const boxes = Object.values(collectionBoxes.docs).sort((a, b) => {
    const boxSrNoA = a.data().boxSrNo || a.data().boxId
    const boxSrNoB = b.data().boxSrNo || b.data().boxId
    return boxSrNoA > boxSrNoB ? 1 : -1
  })

  let srNo = 1
  const fileList = []
  boxes.forEach((doc) => {
    const box = doc?.data()?.boxInfo
    if (box !== undefined) {
      fileList.push({
        ...box,
        Sr_No: srNo++,
        skpBoxId: doc.data().boxId || doc.id,
      })
    }
  })
  return fileList
}

const FileDetailsList = forwardRef((props, ref) => {
  const [state, setState, getState] = useMergeState(initialSlate)
  const pathParams = location.pathname.split('/')
  const jobId = pathParams[2]
  const boxesKeyed = props
  const boxes = boxesKeyed.boxCount
  const refLocalToast = useRef(null)
  const theme = useTheme()
  const boxId = props.boxId
  const isViewAllFilesForJob = props.isViewAllFilesForJob
  const tableRef = useRef(null)

  const loadFileDetailsData = async () => {
    const rawJobByIdData = await gdeTransactions.getJobById(jobId)
    const jobData = rawJobByIdData.data()
    const [, , , , skpEncoding] = await gdeTransactions.getGdeConfig()
    const regexFormat = skpEncoding[jobData?.countryCode]?.regex
    const { columnList, templateName, templateType } = buildFileDetailsColumns(jobData, jobId, regexFormat, getState)

    setState({
      columnsList: columnList,
      templateName,
      jobDetails: jobData,
      jobStatus: jobData.jobStatus,
      regexFormat,
      boxCount: boxes,
      showTable: true,
      filesLoading: true,
      fileList: [],
      boxList: [],
    })

    const boxListWithStatus = await getTransmittedBoxIds(jobId, jobData.jobStatus)
    const isFileTemplate = templateType === 'New File' || templateType === 'Maintenance File'
    let fileList
    let boxList = []
    if (isFileTemplate) {
      const result = await fetchAllFilesForJob(jobId)
      fileList = result.fileList
      boxList = result.boxList
    } else {
      fileList = await fetchBoxRecordsForJob(jobId)
      boxList = fileList
    }

    setState({
      fileList,
      boxList,
      columnsList: columnList,
      templateName,
      jobDetails: jobData,
      jobStatus: jobData.jobStatus,
      boxCount: boxes,
      boxListWithStatus,
      showTable: true,
      filesLoading: false,
    })
  }

  useEffect(() => {
    loadFileDetailsData()
  }, [])

  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.jobManagement'
      subTitle={<><GoBackSubtitle id={'boxList_goBack'}
      /><DetailsSubtitle templateSelected={getState()?.jobDetails?.dataEntryType} onShowJobList={props.onShowJobList} onShowFileList={props.onShowFileList} onShowBoxList={props.onShowBoxList} fileColor={props.fileColor} /></>}
      buttons={<Buttons isViewAllFilesForJob={isViewAllFilesForJob} />}>
      <BoxUp theme={theme}>
        <LocalToast ref={refLocalToast} />
        <YDivider height='15px' />
        <FlexByRow>
          <XDivider width="15px" />
          <BoxStyle theme={theme}>
            <Box>
              <LableStyle><Label>dataEntry.jobId</Label></LableStyle>
              <YDivider />
              <LableStyle><Label noTranslate>{state?.jobDetails?.jobId}</Label></LableStyle>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
            <Box>
              <LableStyle><Label>dataEntry.customerId</Label></LableStyle>
              <YDivider />
              <LableStyle><Label noTranslate>{state?.jobDetails?.accountLevel1?.toUpperCase()}</Label></LableStyle>
            </Box>
          </BoxStyle>
          <BoxStyle theme={theme}>
            <Box>
              <LableStyle><Label>dataEntry.templateName</Label></LableStyle>
              <YDivider />
              <LableStyle><Label noTranslate>{state.templateName}</Label></LableStyle>
            </Box>
          </BoxStyle>
          {getState()?.jobDetails?.dataEntryType === 'New Box' || getState()?.jobDetails?.dataEntryType === 'Maintenance Box'
            ? (
              <>
                <BoxStyle theme={theme}>
                  <Box>
                    <LableStyle><Label>dataEntry.boxesCompleted</Label></LableStyle>
                    <YDivider />
                    <LableStyle theme={theme}>{state.fileList.length}</LableStyle>
                  </Box>
                </BoxStyle>
                <XDivider width="15px" />
              </>
              )
            : (
              <>
                <BoxStyle theme={theme}>
                  <Box>
                    <LableStyle><Label>dataEntry.boxesCompleted</Label></LableStyle>
                    <YDivider />
                    <LableStyle theme={theme}>{state.boxList.length}</LableStyle>
                  </Box>
                </BoxStyle>
                <BoxStyle theme={theme}>
                  <Box>
                    <Label><Label>dataEntry.filesKeyed</Label></Label>
                    <YDivider />
                    <PrimaryLabel theme={theme}>{state.fileList.length}</PrimaryLabel>
                  </Box>
                </BoxStyle>
                <XDivider width="15px" />
              </>
              )
          }
        </FlexByRow>
      </BoxUp>
      <YDivider height='30px' />
      {state.showTable && (
        /* Replaced BulkUpdateTable with QC DataGrid for faster load/edit */
        <QcDataGridBulkUpdateTable
          fileList={state.fileList}
          columnsList={state.columnsList}
          filesLoading={state.filesLoading}
          tableRef={tableRef}
          boxId={boxId}
          jobId={jobId}
          dataEntryType={getState()?.jobDetails?.dataEntryType}
          jobStatus={getState()?.jobDetails?.jobStatus}
          editTable={true}
          boxListWithStatus={state.boxListWithStatus}
          isFromQC={false}
          qualityCheck={false}
        />
      )}
    </MainRouteSubRoutePage>
  )
})

BoxesList.propTypes = {
  onShowJobList: PropTypes.func,
  onShowBoxList: PropTypes.func,
  onShowFileList: PropTypes.func,
  boxColor: PropTypes.bool
}

JobDetailsList.propTypes = {
  onShowJobList: PropTypes.func,
  onShowBoxList: PropTypes.func,
  onShowFileList: PropTypes.func,
  jobColor: PropTypes.bool
}

FileDetailsList.propTypes = {
  onShowJobList: PropTypes.func,
  onShowBoxList: PropTypes.func,
  onShowFileList: PropTypes.func,
  // fileList: PropTypes.object,
  // jobId: PropTypes.string,
  boxId: PropTypes.string,
  isViewAllFilesForJob: PropTypes.string,
  fileColor: PropTypes.bool
}

const JobDetails = props => {
  const [showTable, setShowTable] = useState('boxList')
  const [boxColor, setBoxColor] = useState(true)
  const [jobColor, setJobColor] = useState(false)
  const [fileColor, setFileColor] = useState(false)

  const onShowBoxList = () => {
    setShowTable('boxList')
    setBoxColor(true)
  }

  const onShowJobList = () => {
    setShowTable('jobDetail')
    setJobColor(true)
  }

  const onShowFileList = () => {
    setShowTable('fileDetail')
    setFileColor(true)
  }

  if (showTable === 'boxList') {
    return (
      <BoxesList onShowJobList={onShowJobList} onShowBoxList={onShowBoxList} onShowFileList={onShowFileList} boxColor={boxColor} />
    )
  } else if (showTable === 'jobDetail') {
    return (
      <JobDetailsList onShowBoxList={onShowBoxList} onShowJobList={onShowJobList} onShowFileList={onShowFileList} jobColor={jobColor} />
    )
  } else if (showTable === 'fileDetail') {
    return (
      <FileDetailsList onShowBoxList={onShowBoxList} onShowJobList={onShowJobList} onShowFileList={onShowFileList} fileColor={fileColor} />
    )
  }
}


export default JobDetails
